import { render, staticRenderFns } from "./CustomerPrototypeCard.vue?vue&type=template&id=4a6e65c7&scoped=true"
import script from "./CustomerPrototypeCard.vue?vue&type=script&lang=js"
export * from "./CustomerPrototypeCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerPrototypeCard.vue?vue&type=style&index=0&id=4a6e65c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6e65c7",
  null
  
)

export default component.exports